<ng-container *ngIf="show">
  <button
    class="py-1 px-4 bg-blue-100 border border-blue-500 rounded-xl text-blue-500"
    testId="tracked-attributes-prompt"
    (click)="openDialog()"
  >
    <p>{{ promptText }}</p>
  </button>
</ng-container>
